import { Component } from '@angular/core';
import {AccordionComponent, AccordionElementComponent} from "@husbanken/designsystem-angular-core";

@Component({
  selector: "bko-last-ned-pdf-card",
  imports: [AccordionComponent, AccordionElementComponent],
  templateUrl: "./last-ned-pdf-card.html",
  styleUrl: "./last-ned-pdf-card.scss",
})
export class LastNedPdfCard {}
